import React, { useMemo, useState, useCallback } from 'react';
import { Flex, ListBox, Item, View, Link } from '@adobe/react-spectrum';
import { ChevronDown, ChevronUp, CircleFill } from 'react-bootstrap-icons';
import { truncateText } from '../../../../utils/helperUtil';
import { useTranslation } from 'react-i18next';
import styles from './type_of_work_filter.module.css';

interface IIssueTypeFilterComponentProps {
  createParams: (filterType: any, filterValue: any) => void;
  filterParams?: any;
  issueTypes?: Array<{ id: string; name: string }>;
}

const IssueTypeFilterComponent: React.FC<IIssueTypeFilterComponentProps> = ({
  createParams,
  filterParams,
  issueTypes = [],
}) => {
  const { t } = useTranslation('issue');
  const _t = useCallback((key: string) => t(`issue_filters.${key}`, { ns: 'issue' }), [t]);
  const [toggleListVisibility, setToggleListVisibility] = useState<any>({ stateList: true });
  const selectedFilter = filterParams?.FILTER.COL.find((col: any) => col.name === 'customState')?.value;
  const [selectedKey, setSelectedKey] = useState<Set<string>>(
    new Set(
      selectedFilter
        ? Array.from(selectedFilter instanceof Set ? selectedFilter : [selectedFilter]).map(String)
        : [_t('all_types')]
    )
  );

  const items = useMemo(
    () => [
      { ident: _t('all_types'), title: _t('all_types'), color: '#6c757d' },
      ...issueTypes.map((item, index) => ({
        ident: item.id,
        title: item.name,
        color: ['#0d6efd', '#198754', '#ffc107', '#dc3545'][index % 4],
      })),
    ],
    [_t, issueTypes]
  );

  const handleSelectionChange = (value: any) => {
    const arrValue = Array.from(value);
    const next = arrValue.length > 0 ? new Set(arrValue.map(String)) : new Set([_t('all_types')]);
    setSelectedKey(next);
    createParams('customState', next);
  };

  return (
    <Flex direction="column" minWidth="200px" alignSelf="stretch" alignItems="start" justifyContent="start" UNSAFE_style={{ overflowY: 'auto' }}>
      <Flex direction="column" gap="4px" alignSelf="stretch" alignItems="start" justifyContent="start" UNSAFE_className={styles.type_of_work_container}>
        <Flex direction="row" height="36px" alignSelf="stretch" alignItems="center" justifyContent="space-between" UNSAFE_className={styles.type_of_work_heading}>
          <Flex direction="row" flex={1} alignItems="center" justifyContent="start">
            <View position="relative" UNSAFE_className={styles.type_of_work_heading_text}>
              {_t('type_of_request')}
            </View>
          </Flex>
          {toggleListVisibility.stateList ? (
            <ChevronDown color="#B0BEC5" onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: false }))} style={{ cursor: 'pointer' }} />
          ) : (
            <ChevronUp onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: true }))} style={{ cursor: 'pointer' }} />
          )}
        </Flex>
        <Flex
          direction="column"
          alignSelf="stretch"
          alignItems="start"
          justifyContent="start"
          UNSAFE_className={styles.type_of_work_component}
          UNSAFE_style={{ display: toggleListVisibility.stateList ? '' : 'none' }}
        >
          <ListBox
            id="listIssueType"
            width="100%"
            selectionMode="single"
            defaultSelectedKeys={selectedKey}
            selectedKeys={selectedKey}
            items={items}
            onSelectionChange={handleSelectionChange}
            aria-label="Issue type filter"
          >
            {(item: any) => (
              <Item key={item.ident} textValue={item.title}>
                <Flex direction="row" height="30px" UNSAFE_style={{ paddingBottom: '30px' }}>
                  <View UNSAFE_style={{ paddingTop: '4px', paddingLeft: '4px' }}>
                    <CircleFill style={{ paddingRight: '10px' }} size="18px" color={item.color} />
                  </View>
                  <View UNSAFE_style={{ whiteSpace: 'nowrap', color: '#455a64 !important', paddingTop: '5px' }}>
                    <span title={item.title}>{truncateText(item.title, 18)}</span>
                  </View>
                </Flex>
              </Item>
            )}
          </ListBox>
          <View position="relative" width="100%" height="20px" UNSAFE_className={styles.type_of_work_clear_all_container}>
            <View position="relative" UNSAFE_className={styles.type_of_work_clear_all_text}>
              <Link onPress={() => handleSelectionChange(new Set([_t('all_types')]))}>{t('clear_all', { ns: 'layout_components' })}</Link>
            </View>
          </View>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default IssueTypeFilterComponent;
